import { Box, OsStack, Typography } from "@outschool/backpack";
import { ActivityListing_ListingFragment } from "@outschool/gql-frontend-generated";
import { UserHeadshotImage } from "@outschool/ui-components-shared";
import { SimpleRatings } from "@outschool/ui-components-website";
import React from "react";

/**
 * TeacherInfo for the search results gallery experiment listing card.
 *
 * Extracts logic from DesktopListing.tsx to display the teacher info section of the listing card.
 */
export default function TeacherInfo({
  leader,
}: {
  leader: ActivityListing_ListingFragment["leader"];
}) {
  return (
    <Box
      sx={{
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
        padding: "4px",
      }}
    >
      <OsStack direction="row" spacing={1} alignItems="center">
        <Box sx={{ padding: "4px" }}>
          <UserHeadshotImage
            user={leader}
            size={40}
            sx={{ border: "1px solid", borderColor: "gray200" }}
          />
        </Box>
        <Box
          flex
          sx={{
            width: "100%",
            gap: "4px",
            flexDirection: "column",
            minWidth: 0, // Allow flex item to shrink below content size for ellipsis overflow on Typography below
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "grey.600",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {leader.name}
          </Typography>
          <SimpleRatings
            starRating={leader.averageActivityStarRating}
            reviewCount={leader.reviewCount}
          />
        </Box>
      </OsStack>
    </Box>
  );
}
